import axios from 'axios';
import { getUserData } from './storageService';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://backend-c-0mxm.onrender.com';
const API_URL = BASE_URL.replace(/\/api$/, '');

const getAuthHeaders = () => {
  const user = getUserData();
  return {
    Authorization: `Bearer ${user?.userId || ''}`
  };
};

const api = axios.create({
  baseURL: `${API_URL}/api/google`,
});

api.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...getAuthHeaders() };
  return config;
});

const googleAuthService = {
  /**
   * Check if user has authorized Google
   */
  getStatus: async () => {
    const response = await api.get('/status');
    return response.data;
  },

  /**
   * Get authorization URL
   */
  getAuthUrl: async () => {
    const response = await api.get('/auth-url');
    return response.data;
  },

  /**
   * Disconnect Google account
   */
  disconnect: async () => {
    const response = await api.post('/disconnect');
    return response.data;
  },

  /**
   * Open Google authorization in new window
   */
  authorize: async () => {
    try {
      const result = await googleAuthService.getAuthUrl();
      if (result.success && result.authUrl) {
        // Open in same window (will redirect back after auth)
        window.location.href = result.authUrl;
      }
    } catch (error) {
      console.error('Error getting auth URL:', error);
      throw error;
    }
  },
};

export default googleAuthService;
